import { createRoute } from "@tanstack/react-router";
import { customerLayoutRoute } from "../../Dashboard";

export const resourcePagesRoute = createRoute({
  getParentRoute: () => customerLayoutRoute,
  path: "resources",
}).lazy(() => import("./ResourcePages.lazy").then((d) => d.Route));
